<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import { Plus } from 'lucide-vue-next'
import PensionProgressChart from './PensionProgressChart.vue'

const router = useRouter()
const isModalOpen = ref(false)

const navigateToScreen = (route: string) => {
  isModalOpen.value = false
  router.push(route)
}
</script>

<template>
  <div class="bg-white w-full rounded-2xl py-6 flex flex-col items-center">
    <div class="w-full flex justify-center">
      <PensionProgressChart />
    </div>

    <div class="flex items-center justify-center mt-4">
      <div class="relative flex items-center gap-4">
        <button
          class="h-[49px] w-[148px] bg-accent text-accent-foreground font-bold rounded-full flex items-center justify-center gap-3"
          @click="isModalOpen = true"
        >
          <span>Get Maxing</span>
          <Plus class="w-4 h-4" />
        </button>
        <!-- <HelpCircle class="absolute top-4.5 -right-6 w-4 h-4 text-gray-400" /> -->
      </div>
    </div>

    <!-- Modal -->
    <Dialog :open="isModalOpen" @update:open="isModalOpen = $event">
      <DialogContent class="sm:max-w-[425px] p-4 pt-10 rounded-2xl">
        <div class="flex flex-col gap-4">
          <button
            class="h-10 w-full bg-gray-50 rounded-full flex items-center justify-center font-semibold"
            @click="navigateToScreen('/contribute')"
          >
            Contribute
          </button>
          <button
            class="h-10 w-full bg-gray-50 rounded-full flex items-center justify-center font-semibold"
            @click="navigateToScreen('/direct-debit')"
          >
            Direct debit
          </button>
          <button
            class="h-10 w-full bg-gray-50 rounded-full flex items-center justify-center font-semibold"
            @click="navigateToScreen('/round-payment')"
          >
            Round payment
          </button>
        </div>
      </DialogContent>
    </Dialog>
  </div>
</template>
